import { Checkbox, Tag } from 'antd'
import React from 'react'

function CalendarsMenu(props) {
  const { calendars, selectedCalendars, onChange } = props
  return (
    <div className="space-x-3">
      {calendars.map((c) => (
        <Checkbox key={c._key} checked={selectedCalendars.indexOf(c._id) > -1} onChange={() => onChange(c._id)}>
          <Tag color={c.color}>
            <span className="text-white text-base"> {c.name}</span>
          </Tag>
        </Checkbox>
      ))}
    </div>
  )
}

export default CalendarsMenu
